<app-datatable
  tableId="exam-report-table"
  [dataSourceUrl]="this.dtDataSourceUrl"
  [settings]="this.dtSettings"
  [events]="this.dtEvents"
  (onInit)="this.onInit($event)"
>
  <th class="column-hide" data-data="id">Id</th>
  <th data-data="name">Név</th>
  <th data-data="description">Leírás</th>
  <th data-data="defaultGrossTimeLimitMinutes">Bruttó időkeret (perc)</th>
  <th data-data="contentLanguage">Nyelv</th>
  <th class="column-actions">Műveletek</th>
</app-datatable>
